import { BundlecartConstants, cartConstants } from "../_constants";
import { handleAddToCart, handleRemoveCartItem } from "../_helpers";

const initialState = {
  cartItems: [],
  wishlistItems: [],
  loading: false,
  bundleCartItems: [],
};

export const cart = (state = initialState, action) => {
  switch (action.type) {
    case cartConstants.FETCH_CART_START:
      return { ...state, loading: true };
    case cartConstants.FETCH_CART_END:
      return { ...state, loading: false, cartItems: action.payload };
    case cartConstants.ADD_TO_CART_PROCESSING:
      return {
        ...state,
        currentState: "processing",
        currentItem: action.payload,
      };
    case cartConstants.ADD_TO_CART_SUCCESS:
      return {
        ...state,
        currentState: "success",
        loading: false,
      };
    case cartConstants.ADD_TO_CART_FAILED:
      return {
        ...state,
        currentState: "failed",
        loading: false,
        error: action.payload,
      };
    case cartConstants.ADD_TO_CART_RESET:
      return {
        ...state,
        currentItem: null,
        currentState: null,
      };
    case cartConstants.REMOVE_CART_ITEM:
      return {
        ...state,
        currentItem: action.payload,
      };
    case cartConstants.CLEAR_CART:
      return {
        ...state,
        ...initialState,
      };
    case cartConstants.CHECKOUT_PROCESSING:
      return {
        ...state,
        isProcessing: true,
      };
    case cartConstants.CHECKOUT_SUCCESS:
      return {
        ...state,
        isProcessing: false,
        isSuccess: true,
        data: action.payload,
      };
    case cartConstants.CHECKOUT_FAILURE:
      return {
        ...state,
        isProcessing: false,
        isSuccess: false,
        data: action.payload,
      };
    case cartConstants.FETCH_WISHLIST_START:
      return { ...state, loading: true };
    case cartConstants.FETCH_WISHLIST_END:
      return { ...state, loading: false, wishlistItems: action.payload };
    // case BundlecartConstants.FETCH_CART_START:
    //   return { ...state, loading: true };
    // case BundlecartConstants.FETCH_CART_END:
    //   return { ...state, loading: false, bundleCartItems: action.payload };
    // case BundlecartConstants.ADD_TO_CART_PROCESSING:
    //   return {
    //     ...state,
    //     currentState: "processing",
    //     bundleCartItems: action.payload,
    //   };
    // case BundlecartConstants.ADD_TO_CART_SUCCESS:
    //   return {
    //     ...state,
    //     currentState: "success",
    //     loading: false,
    //   };
    // case BundlecartConstants.ADD_TO_CART_FAILED:
    //   return {
    //     ...state,
    //     currentState: "failed",
    //     loading: false,
    //     error: action.payload,
    //   };
    // case BundlecartConstants.ADD_TO_CART_RESET:
    //   return {
    //     ...state,
    //     currentItem: null,
    //     currentState: null,
    //   };
    // case BundlecartConstants.REMOVE_CART_ITEM:
    //   return {
    //     ...state,
    //     bundleCartItems: handleRemoveCartItem({
    //       prevItems: state.bundleCartItems,
    //       bundleCartItems: action.payload,
    //     }),
    //   };
    // case BundlecartConstants.CLEAR_CART:
    //   return {
    //     ...state,
    //     ...initialState,
    //   };
    // case BundlecartConstants.CHECKOUT_PROCESSING:
    //   return {
    //     ...state,
    //     isProcessing: true,
    //   };
    // case BundlecartConstants.CHECKOUT_SUCCESS:
    //   return {
    //     ...state,
    //     isProcessing: false,
    //     isSuccess: true,
    //     data: action.payload,
    //   };
    // case BundlecartConstants.CHECKOUT_FAILURE:
    //   return {
    //     ...state,
    //     isProcessing: false,
    //     isSuccess: false,
    //     data: action.payload,
    //   };
    // case BundlecartConstants.FETCH_WISHLIST_START:
    //   return { ...state, loading: true };
    // case BundlecartConstants.FETCH_WISHLIST_END:
    //   return { ...state, loading: false, wishlistItems: action.payload };
    default:
      return state;
  }
};
